export enum Types {
    NUMBER =  'number',
    BOOLEAN = 'boolean'
}
  